import { OrderDirection, SortOrder } from 'common/utils/commonTypes';
import { AppliedEntityDocumentsOrderBy } from 'common/types/globalTypes';

type OrderLookup = {
  [direction in OrderDirection]: AppliedEntityDocumentsOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'transactionType',
    {
      [OrderDirection.ASC]: [
       'TRANSACTION_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
       'TRANSACTION_TYPE_DESC',
      ],
    },
  ],
  [
    'accountingStampTransactionReference',
    {
      [OrderDirection.ASC]: [
       'ACCOUNTING_STAMP_TRANSACTION_REFERENCE_ASC',
      ],
      [OrderDirection.DESC]: [
       'ACCOUNTING_STAMP_TRANSACTION_REFERENCE_DESC',
      ],
    },
  ],

  [
    '_createdDate',
    {
      [OrderDirection.ASC]: [
       '_CREATED_DATE_ASC',
      ],
      [OrderDirection.DESC]: [
       '_CREATED_DATE_DESC',
      ],
    },
  ],
  [
    'vendorReference',
    {
      [OrderDirection.ASC]: [
       'VENDOR_REFERENCE_ASC',
      ],
      [OrderDirection.DESC]: [
       'VENDOR_REFERENCE_DESC',
      ],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: [
       'DESCRIPTION_ASC',
      ],
      [OrderDirection.DESC]: [
       'DESCRIPTION_DESC',
      ],
    },
  ],
  [
    'invoiceNumber',
    {
      [OrderDirection.ASC]: [
       'INVOICE_NUMBER_ASC',
      ],
      [OrderDirection.DESC]: [
       'INVOICE_NUMBER_DESC',
      ],
    },
  ],
  [
    'invoiceDate',
    {
      [OrderDirection.ASC]: [
       'INVOICE_DATE_ASC',
      ],
      [OrderDirection.DESC]: [
       'INVOICE_DATE_DESC',
      ],
    },
  ],
  [
    'controlTotalAmount',
    {
      [OrderDirection.ASC]: [
       'CONTROL_TOTAL_AMOUNT_ASC',
      ],
      [OrderDirection.DESC]: [
       'CONTROL_TOTAL_AMOUNT_DESC',
      ],
    },
  ],
  [
    'openingBalance',
    {
      [OrderDirection.ASC]: [
       'OPENING_BALANCE_ASC',
      ],
      [OrderDirection.DESC]: [
       'OPENING_BALANCE_DESC',
      ],
    },
  ],
  [
    'appliedAmount',
    {
      [OrderDirection.ASC]: [
       'APPLIED_AMOUNT_ASC',
      ],
      [OrderDirection.DESC]: [
       'APPLIED_AMOUNT_DESC',
      ],
    },
  ],
  [
    'distributedAmount',
    {
      [OrderDirection.ASC]: [
       'DISTRIBUTED_AMOUNT_ASC',
      ],
      [OrderDirection.DESC]: [
       'DISTRIBUTED_AMOUNT_DESC',
      ],
    },
  ],
  [
    'differenceAmount',
    {
      [OrderDirection.ASC]: [
       'DIFFERENCE_AMOUNT_ASC',
      ],
      [OrderDirection.DESC]: [
       'DIFFERENCE_AMOUNT_DESC',
      ],
    },
  ],
  [
    'retiredAmount',
    {
      [OrderDirection.ASC]: [
       'RETIRED_AMOUNT_ASC',
      ],
      [OrderDirection.DESC]: [
       'RETIRED_AMOUNT_DESC',
      ],
    },
  ],
  [
    'remainingBalance',
    {
      [OrderDirection.ASC]: [
       'REMAINING_BALANCE_ASC',
      ],
      [OrderDirection.DESC]: [
       'REMAINING_BALANCE_DESC',
      ],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: AppliedEntityDocumentsOrderBy[] = [
    'ACCOUNTING_STAMP_TRANSACTION_REFERENCE_ASC',
    'ACCOUNTING_STAMP_DATE_ASC',
  ];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};
